/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum InvestorsSortingColumn {
    INVESTOR = 'investor',
    INVESTMENT_STATUS = 'investment_status',
    APPROVAL_STATUS = 'approval_status',
    TOTAL_SECURITIES = 'total_securities',
    TOTAL_HOLDINGS = 'total_holdings',
    TOTAL_PENDING = 'total_pending',
    LAST_LOGIN = 'last_login',
    INVESTMENT_VEHICLE = 'investment_vehicle',
    CITIZENSHIP = 'citizenship',
    EMPLOYEE_ID = 'employee_id',
}
